'use strict';

const { encodeURIComponent: encoder, decodeURIComponent: decoder } = window;

/**
 * Работа с `document.cookie`
 * @namespace cookieData
 */
const cookieData = {
    /**
     * Добавление записи
     * @param {string} key
     * @param {*} value
     * @param {Object} [options={}]
     * @param {Date|number|string} [options.expires]
     * @param {string} [options.path]
     * @param {string} [options.domain]
     * @param {boolean} [options.secure]
     * @see {@link https://learn.javascript.ru/cookie#функция-setcookie-name-value-options}
     */
    add(key, value, options = {}) {
        let expires = options.expires;

        if (typeof expires === 'number' && expires) {
            const d = new Date();

            d.setTime(d.getTime() + expires * 1000);
            expires = options.expires = d;
        }

        if (expires && expires.toUTCString) {
            options.expires = expires.toUTCString();
        }

        value = encoder(value);

        let updatedCookie = `${key}=${value}`;

        for (const propName in options) {
            updatedCookie += `; ${propName}`;

            const propValue = options[propName];

            if (propValue !== true) {
                updatedCookie += `=${propValue}`;
            }
        }

        document.cookie = updatedCookie;
    },

    /**
     * Получение куки по ключу
     * @param key
     * @return {string|undefined}
     * @see {@link https://learn.javascript.ru/cookie#функция-getcookie-name}
     */
    receive(key) {
        const matches = document.cookie.match(
            new RegExp(
                `(?:^|; )${key.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)` // eslint-disable-line no-useless-escape
            )
        );
        return matches ? decoder(matches[1]) : undefined;
    },

    /**
     * Удаление куки по ключу
     * @param {string} key
     * @see {@link https://learn.javascript.ru/cookie#функция-deletecookie-name}
     */
    delete(key) {
        this.add(key, '', { expires: -1 });
    },
};

export default cookieData;
